import { useLayoutEffect } from "react"

export const useReadMoreButton = (queryRef, collapseText, expandedText) => {
  const toggleReadMoreElement = (
    element,
    expandedElement,
    collapseText,
    expandedText
  ) => {
    try {
      const isExpand = JSON.parse(element.getAttribute("toggle"))
      if (!isExpand) {
        expandedElement.classList.replace("max-h-0", "max-h-[99999px]")
        element.innerHTML = expandedText
        element.setAttribute("toggle", true)
      } else {
        expandedElement.classList.replace("max-h-[99999px]", "max-h-0")
        element.innerHTML = collapseText
        element.setAttribute("toggle", false)
      }
    } catch (err) {
      throw Error("Error at toggleReadMoreElement")
    }
  }

  useLayoutEffect(() => {
    const expandedElement = queryRef.current.querySelector(".section-more")
    const readMoreBtn = queryRef.current.querySelector(".btn-read-more")

    if (!expandedElement || !readMoreBtn) return

    readMoreBtn.addEventListener("click", e =>
      toggleReadMoreElement(
        e.target,
        expandedElement,
        collapseText,
        expandedText
      )
    )

    return () =>
      readMoreBtn.removeEventListener("click", e =>
        toggleReadMoreElement(
          e.target,
          expandedElement,
          collapseText,
          expandedText
        )
      )
  }, [queryRef, collapseText, expandedText])
}
